export const REGISTRATION_ROUTE_BASE = "/register";

export const REGISTRATION_MESSAGE_TYPES = {
  REGISTRATION_SUCCESS: "REGISTRATION_SUCCESS",
  REDIRECT_TO_LOGIN: "REDIRECT_TO_LOGIN",
  REDIRECT_TO_HOME: "REDIRECT_TO_HOME",
  REDIRECT_TO_PROFILE: "REDIRECT_TO_PROFILE",
  DISPLAY_ERROR_MODAL: "DISPLAY_ERROR_MODAL",
  REDIRECT_TO_URI: "REDIRECT_TO_URI",
} as const;

export const DUMMY_QUICKCODE = "APUB-2024-ONEOK";

/** UI-only Quick Code hint (shape like ECQX-1831-91DEV; not a real or meaningful code). */
export const QUICK_CODE_INPUT_PLACEHOLDER = "ABCD-1234-XY99";

export type RegistrationMessageType =
  (typeof REGISTRATION_MESSAGE_TYPES)[keyof typeof REGISTRATION_MESSAGE_TYPES];

export const STAKEHOLDER_OPTIONS = [
  { value: "ER - Emergency Responder", label: "Emergency Responder" },
  { value: "AP - Affected Public", label: "Member of the Public" },
  { value: "EX - Excavator", label: "Excavator" },
  { value: "FM - Farmer", label: "Farmer" },
  { value: "PO - Public Official", label: "Public Official" },
  { value: "SC - School Rep", label: "School Representative" },
  { value: "OT - Other", label: "Other" },
] as const;

export const ER_STAKEHOLDER_TYPES = [
  "ET - Tier II",
  "EC - Commander",
  "ER - Emergency Responder",
] as const;

